module.exports = __webpack_public_path__ + "assets/iphone.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/devices/iphone.png
// module id = 991
// module chunks = 19